export class UIRoot {
  readonly element: HTMLElement;

  constructor(parent: HTMLElement) {
    this.element = document.createElement('div');
    this.element.className = 'ui-root';
    parent.appendChild(this.element);
  }

  mountLayer(layer: HTMLElement): void {
    this.element.appendChild(layer);
  }

  dispose(): void {
    this.element.remove();
  }
}
